import React from "react";
import { Grid } from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import styles from "./insights.module.scss";

export const UniPageAnalyticsInsights = () => {
  return (
    <section className={styles.section_insights}>
      <div className="container">
        <Grid container spacing={5} alignItems="center">
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_indepth.png")}
                alt="Uni indepth"
              />
            </div>
          </Grid>

          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>
              In-Depth Insights into Emerging Markets
            </h2>
            <p className={`${styles.sub_title} font-medium`}>
              As our university partner, you have exclusive access to our annual
              market insight reports, which overview the most significant trends
              and patterns in target audience behaviour and international
              student recruitment within emerging markets.
            </p>
            <p className={`font-medium`}>
              Pinpoint growth opportunities and stay ahead of the curve with
              informed insights based on up-to-date data analytics.
            </p>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageAnalyticsInsights;
